module.exports = __webpack_public_path__ + "img/fancom-logo.28c09a75.svg";